import { CamposGenericos } from "./camposGenericos";
import { StockPedido } from "./stockPedido";

export class CuotaDistribuidor extends CamposGenericos {
    anio: string;
    cantidadDisponibleVenta: number;
    cantidadDisponibleVigente: number;
    cantidadPedidos: number;
    cantidadPedidosNoFacturados: number;
    cantidadTransito: number;
    cantidadTransitoDevolucion: number;
    cuotaCant: number;
    idCompania: string;
    idPais: string;
    idProducto: string;
    idRegion: string;
    idSalesOrg: string;
    idSucursal: string;
    jerarquiaProducto: string;
    mes: string;
    mesyAnio: string;
    nroClienteDistribuidor: string;
    distribuidor: string;
    producto: string;
    listaStockPedidos: StockPedido[] = [];
    region: string;
    sucursal: string;
    fecha:Date;

}